import { Messages } from '~src/codegen/Localize';

export function getLocalizedDomainName(domain: string) {
    return domain === 'local' ? Messages.local() : domain;
}